<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/transmission/240kW/240kW.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">

                <div class="detail-banner-t2">240kW Two-speed Three-in-one Electric Drive</div>
                <div class="detail-banner-desc transmission">800V two-speed high-load 3-in-1 electric drive assembly with integrated
                    boost fast-charging function
                    <div class="detail-desc">
                        <div>
                            The Triple-in-One High-Power Electric Bridge integrates differential lock,boost charging,and
                            direct charging functions,with maximum boost charging power reaching up to
                            120kW,significantly enhancing the vehicle's charging eficiency;<br />
                        </div>
                        <div>
                            The motor emloys a wate-coling and oil-cooling composite cooling system,improving cooling
                            capacityby 25% and enhancing the motor's continous output capability;<br />
                        </div>
                        <div>
                            The system pioneers intergration of a self- developed 1200V silicon carbide(Sic)
                            module,incorporating ultra-thin silicon steel laminations,segmented permanent magnet
                            design,enhancing overall system efficiency.
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">

                <div class="one-titile">
                    Core Configuration
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/transmission/240kW/240kW-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">240kW</div>
                                    <div class="k">Peak Power</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">18000rpm</div>
                                    <div class="k">Max Speed</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">8500N·m</div>
                                    <div class="k">Max. Wheel Torque</div>
                                </div>

                                <div class="spec-item">
                                    <div class="v">2</div>
                                    <div class="k">Gear</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">550*600*437</div>
                                    <div class="k">Dimension X*Y*Z(mm)</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Water + Oil cooling system</div>
                                    <div class="k">Cooling</div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '240kW Two-speed Three-in-one Electric Drive - FINEST Website',
    keywords: 'FINEST,Engine,Transmission,Electronics',
    description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/transmission/240.html'

};

import { createApp } from 'vue';
import App from './240.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./240.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
